<script setup>
defineProps({
    error: {
        type: String,
        required: true
    }
})
</script>

<template>
    <div v-if="error" class="error-bar">
        <ah-icon name="exclaim-circle" />
        <p>{{ error }}</p>
    </div>
</template>

<style lang="scss">
    .error-bar {
        background: var(--color-secondary-orange);
        border-radius: 2.4rem;
        color: var(--color-white-100);
        display: flex;
        align-items: center;
        padding: 1rem 2rem;
        min-height: 6rem;
        max-width: 100%;

        p {
            @include font(1.4, null, black);
        }

        .icon {
            fill: #fff;
            margin-right: 1rem;
        }
    }
</style>
